import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import SwiperCore, {
  Autoplay, Pagination, EffectFade
} from 'swiper';
import { utility } from "../../../utility/utility";
import { DISPLAYPLATFORM, OTT_POSTER_TYPE, RAILTYPE } from "../../../constant";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useContext } from "react";
import { PlatformContext } from "../../../contexts/platformContext";
import { useNavigate } from "react-router-dom";

const HeroBanner = (props) => {
  const navigate = useNavigate();
  const { ref } = useFocusable({
    onFocus: () => {
      // scroll to top
      props.setOttAsset(null);
      ref.current.scrollTo(0, 0);
    }
  });

  const displayPlatform = useContext(PlatformContext);
  const isWeb = displayPlatform === DISPLAYPLATFORM.WEB;

  const isPotrait = isWeb || props.rail.OttRailTypeSID == RAILTYPE.HeroBannerPotrait;

  const onClick = (asset) => {
    utility.onAssetClick(asset, props.ottSetting, navigate, displayPlatform,);
  }

  return <div ref={ref}>

    <Swiper
      pagination={{
        type: 'bullets',
        clickable: 'true'
      }}
      modules={[Pagination, Autoplay, EffectFade]}
      slidesPerView={1}
      spaceBetween={500}
      centeredSlides={true}
      speed={500}
      direction='horizontal'
      className='mySwiper'
      keyboard={{
        enabled: true
      }}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false
      }}
    >
      {props.rail.OttAsset.map((asset, index) => {
        return <SwiperSlide>
          <div className="heroBannerContainer" style={{ padding: isPotrait ? "0 70px" : "0 30px", height: isPotrait ? "60vh" : "auto", background: "transparent" }}>
            <img src={utility.getPosterUrl(asset.Posters, isPotrait ? OTT_POSTER_TYPE.Portrait : OTT_POSTER_TYPE.Landscape)} className="herobanner" alt="First slide" style={{ aspectRatio: isPotrait ? "2/3" : "16/9", objectFit: "cover", }} />
            {isWeb && <div style={{ position: "absolute", bottom: "70px", left: "100px", width: "100%" }}>
              <p style={{ fontSize: "28px", fontWeight: "bold", color: "white", }}>{asset?.Title ?? "ho"}</p>
              <div style={{ display: "flex", justifyContent: "center", border: "1px solid white", padding: "5px 10px", borderRadius: "10px", alignItems: "center", cursor: "pointer", width: "180px", backgroundColor: "rgba(0,0,0,0.5)", scale: "0.8", position: "relative", right: "20px" }} onClick={() => onClick(asset)}>
                <i className="fa fa-play-circle fa-2x" style={{ color: "white" }} aria-hidden="true" />
                <p style={{ color: "white", paddingLeft: "10px", fontWeight: "bold", position: "relative", top: "8px" }}>Watch Now</p>
              </div>
            </div>}
          </div>

        </SwiperSlide>
      })}


    </Swiper>


  </div>

}

export default HeroBanner;